// NavBar.jsx
import { Link } from 'react-router-dom';
import { useState } from 'react';
import hammerLogo from '../assets/hammer-logo.png'

const NavBar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-[#decbef] sticky top-0 z-50 shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/nails" className="flex items-center">
            <img
              src={hammerLogo}
              alt="NeNe Nail’d It Logo"
              className="h-20 w-auto" // control size here
            /></Link>

          {/* Desktop nav (unchanged) */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/nails/featured" className="nav-link">Featured</Link>
            <Link to="/nails/experience" className="nav-link">Experience</Link>
            <Link to="/nails/signature" className="nav-link">Signature</Link>
            <Link to="/nails/onhand" className="nav-link">Ready To Ship</Link>
            <Link to="/nails/custom" className="nav-link">Build Your Own</Link>
            <Link to="/nails/faq" className="nav-link">FAQs</Link>
            <a
              href="https://www.instagram.com/neneeenaildit"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link block"
              onClick={() => setOpen(false)}
            >
              Follow Me
            </a>
          </nav>

          {/* Mobile button — now green */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 rounded-xl bg-[#e7e9b1] text-[#2a1737] shadow focus:outline-none focus:ring-2 focus:ring-[#2a1737]/20"
            aria-label="Toggle menu"
          >
            <span className="flex items-center justify-center w-full h-full text-2xl leading-[1]">
              {open ? '✖' : '☰'}
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}

      {/* Mobile menu */}
      <div className={`md:hidden ${open ? 'block' : 'hidden'}`}>
        <nav className="mt-4 flex flex-col gap-3 text-center">
          <Link to="/nails/featured" className="nav-link block" onClick={() => setOpen(false)}>
            Featured
          </Link>
          <Link to="/nails/experience" className="nav-link block" onClick={() => setOpen(false)}>
            Experience
          </Link>
          <Link to="/nails/signature" className="nav-link block" onClick={() => setOpen(false)}>
            Signature
          </Link>
          <Link to="/nails/onhand" className="nav-link block" onClick={() => setOpen(false)}>
            Ready To Ship
          </Link>
          <Link to="/nails/custom" className="nav-link block" onClick={() => setOpen(false)}>
            Build Your Own
          </Link>
          <Link to="/nails/faqs" className="nav-link block" onClick={() => setOpen(false)}>
            FAQs
          </Link>
          <a href="https://instagram.com/yourhandle" className="nav-link block" onClick={() => setOpen(false)}>
            Follow Me
          </a>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
